import { useQueryClient } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import { quotaQueryClient } from "app/pages/sales-intelligence/modules/quota/queries/client";
import useSingleRevealContactInfoQuery from "app/pages/sales-intelligence/sub-modules/contacts-search/query/queries/useSingleRevealContactInfoQuery";
import type { IRevealedContactResponse } from "app/pages/sales-intelligence/sub-modules/contacts-search/query/queries/useSingleRevealContactInfoQuery";
import type {
    ContactSearchEntry,
    RevealedContactSearchEntry,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { ContactsResponseDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

interface IResult {
    isLoading: boolean;
    reveal: () => void;
}

function useAgentContactReveal(contact: ContactSearchEntry, ids: string[]): IResult {
    const queryClient = useQueryClient();

    const mutation = useSingleRevealContactInfoQuery(({ revealedInfo }: IRevealedContactResponse) => {
        queryClient.setQueryData(aiAgentQueryKeys.superAgent.contacts(ids), (oldData: ContactsResponseDto) => ({
            ...oldData,
            rows: oldData?.rows?.map((item: ContactSearchEntry): ContactSearchEntry | RevealedContactSearchEntry =>
                item.id === contact.id
                    ? {
                          ...item,
                          isRevealed: true as const,
                          revealedInfo,
                          privateData: revealedInfo,
                      }
                    : item,
            ),
        }));
        void quotaQueryClient.invalidateContactsQuota();
    });

    return {
        isLoading: mutation.isPending,
        reveal: () => mutation.mutate(contact),
    };
}

export default useAgentContactReveal;
